import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  USER_ROLE_ADMIN,
  USER_ROLE_HOUSEHOLD_ADMIN,
} from 'common/userRoles';

import {
  SR_API_ACTION_ADMIN_UPDATE_ITEM,
} from 'api/actionTypes';

import SrPage from 'client/components/SrPage';
import SrFilterCheckbox from 'client/components/SrFilterCheckbox';
import SrTable from 'client/components/SrTable';

import {
  SCREEN_ID_ADMIN_HOUSEHOLD_ROUND_ROBIN_ASSIGNMENT_CONTROL,
} from 'client/constants/screenIds';

import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import allowedRoles from 'client/helpers/allowedRoles';
import withScrollToTop from 'client/helpers/withScrollToTop';
import log from 'client/lib/log';

import branch from 'client/core/branch';
import getHouseholdAdminsList from 'client/actions/Household/getHouseholdAdminsList';
import postWithState from 'client/actions/postWithState';

@withScrollToTop
@withTransitionHook
@allowedRoles({
  roles: [
    USER_ROLE_ADMIN,
    USER_ROLE_HOUSEHOLD_ADMIN,
  ],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withScreenId(SCREEN_ID_ADMIN_HOUSEHOLD_ROUND_ROBIN_ASSIGNMENT_CONTROL)
@branch({
  householdAdminsList: ['householdAdminsList'],
})
class AdminHouseholdRoundRobinAssignmentControl extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Household Admin Assignment Control | Sunroom Rentals',
  })

  static fetchData(match, inject) {
    return getHouseholdAdminsList(inject);
  }

  static propTypes = {
    householdAdminsList: PropTypes.array,
    dispatch: PropTypes.func.isRequired,
  }

  _onToggleLeadsEnabledClick = (householdAdmin) => {
    const { dispatch } = this.props;

    dispatch(postWithState, {
      action: SR_API_ACTION_ADMIN_UPDATE_ITEM,
      payload: {
        table: 'users',
        where: {
          id: householdAdmin.id,
        },
        updates: {
          householdAdminRoundRobinDisabled: !householdAdmin.householdAdminRoundRobinDisabled,
        },
      },
    })
      .then(() => {
        return dispatch(getHouseholdAdminsList, {
          force: true,
        });
      })
      .catch((error) => {
        log.error(error);
      });
  }

  render() {
    const { householdAdminsList } = this.props;

    return (
      <SrPage navbarProps={{ redirectLogoTo: '/admin' }}>
        <div className='width-90'>
          <SrTable
            rows={(householdAdminsList || []).map((householdAdmin) => ({
              cells: [
                { content: householdAdmin.name },
                { content: (
                  <SrFilterCheckbox
                    id={String(householdAdmin.id)}
                    onChange={() => this._onToggleLeadsEnabledClick(householdAdmin)}
                    value={!householdAdmin.householdAdminRoundRobinDisabled}
                  />
                ) },
              ],
            }))}
          />
        </div>
      </SrPage>
    );
  }
}

AdminHouseholdRoundRobinAssignmentControl.displayName = 'AdminHouseholdRoundRobinAssignmentControl';

export default AdminHouseholdRoundRobinAssignmentControl;
